// 📄 mailService.ts
// Cola de correo genérica sobre la extensión de Firebase "Trigger Email"
// (firestore-send-email): escribe un doc en `mail` con la forma que la
// extensión espera y ella se encarga del envío por SMTP. Reutilizable para
// cualquier notificación futura, no solo incidentes.
import { collection, addDoc } from "firebase/firestore";
import { db } from '../firebase';

export interface QueueEmailInput {
  to: string[];
  subject: string;
  html: string;
}

export const queueEmail = async ({ to, subject, html }: QueueEmailInput): Promise<void> => {
  const recipients = [...new Set(to.map(e => e.trim().toLowerCase()).filter(Boolean))];
  if (recipients.length === 0) return;

  await addDoc(collection(db, "mail"), {
    to: recipients,
    message: { subject, html }
  });
};
